export default __webpack_public_path__ + "static/media/Eye_5_F_C5.815cbe26.svg";